// extracted by mini-css-extract-plugin
module.exports = {"root":"DetailsAndPolicies_root__2w8KL"};